import React, { useState } from 'react';
import { useAnalytics } from '../hooks/useAnalytics';
import ClickableLink from './ClickableLink';

const Home = () => {
  const { trackLinkClick, trackResumeView, trackSocialClick, trackContactAttempt } = useAnalytics();
  const [isEmailHovered, setIsEmailHovered] = useState(false);
  const [resumeVersion] = useState(() => {
    const versions = ['quant', 'swe', 'robotics'];
    return versions[Math.floor(Math.random() * versions.length)];
  });

  const resumeHref = `/api/download/resume?version=${resumeVersion}`;

  return (
    <div className="flex min-h-screen flex-col flex-initial items-left self-start justify-center space-y-4 py-8 md:py-0">
      <div className="flex flex-row items-start justify-between text-balance font-sans text-4xl font-black md:items-center md:text-custom-80 sm:text-5xl">
        <div className="grow">
          <span className="mb-4 block">Hi, I'm Ethan.</span>
          <div className="text-base font-semibold sm:text-lg">A senior at Penn, studying Computer Science, Math, Music, and Robotics.</div>
          <div className="text-base font-semibold sm:text-lg">Avid coder, musician, problem-solver.</div>
        </div>
        <img src={'/candid copy.jpeg'} alt="Ethan" className="h-28 w-32 flex-shrink-0 self-end rounded-lg object-cover sm:h-32 sm:w-36 md:h-40 md:w-45 sm:self-center md:self-center" />
      </div>

      <div className="text-base font-medium sm:text-lg">
        Summer 2025, I worked on the{' '}
        <ClickableLink
          href="https://openai.com/careers/research-engineer-retrieval-and-search-applied-engineering/"
          onClick={() => trackLinkClick('https://openai.com/careers/research-engineer-retrieval-and-search-applied-engineering/', 'ChatGPT Search Team', 'work')}
        >
          ChatGPT Search Team
        </ClickableLink>{' '}
        @ OpenAI, advancing multimodal inference capabilities. At the same time, I'm collaborating with the{' '}
        <ClickableLink
          href="https://www.grasp.upenn.edu/research-groups/perception-action-learning-group/"
          onClick={() => trackLinkClick('https://www.grasp.upenn.edu/research-groups/perception-action-learning-group/', 'PAL Group', 'work')}
        >
          PAL Group
        </ClickableLink>{' '}
        and{' '}
        <ClickableLink
          href="https://www.csail.mit.edu/research/robust-robotics-group"
          onClick={() => trackLinkClick('https://www.csail.mit.edu/research/robust-robotics-group', 'MIT CSAIL', 'work')}
        >
          MIT CSAIL
        </ClickableLink>
        , exploring ways to better leverage uncertainty and fidelity into model-based RL.
      </div>

      <div className="text-base font-medium sm:text-lg">
        I’m also an amateur{' '}
        <ClickableLink
          href="https://music.sas.upenn.edu/performance/marian-anderson-performance-program"
          onClick={() => trackLinkClick('https://music.sas.upenn.edu/performance/marian-anderson-performance-program', 'pianist', 'music')}
        >
          pianist
        </ClickableLink>{' '}
        and violinist. During concert season, I’m coached by{' '}
        <ClickableLink
          href="https://music.sas.upenn.edu/ensembles/penn-chamber"
          onClick={() => trackLinkClick('https://music.sas.upenn.edu/ensembles/penn-chamber', 'Penn Chamber', 'music')}
        >
          Penn Chamber
        </ClickableLink>{' '}
        director Thomas Kraines with my{' '}
        <ClickableLink
          href="https://www.youtube.com/watch?v=TuAFTmtQ0X4"
          onClick={() => trackLinkClick('https://www.youtube.com/watch?v=TuAFTmtQ0X4', 'piano quintet', 'music')}
        >
          piano quintet
        </ClickableLink>
        , and led by Maestro Thomas Hong as concertmaster for the{' '}
        <ClickableLink
          href="https://music.sas.upenn.edu/ensembles/penn-symphony-orchestra"
          onClick={() => trackLinkClick('https://music.sas.upenn.edu/ensembles/penn-symphony-orchestra', 'Penn Symphony Orchestra', 'music')}
        >
          Penn Symphony Orchestra
        </ClickableLink>
        .
      </div>

      <div className="text-base font-medium sm:text-lg">Balancing bits and beats. If that sounds intriguing, let’s connect.</div>

      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:gap-0">
        <ClickableLink
          href={resumeHref}
          onClick={() => trackResumeView(resumeVersion)}
          preserveReferrer
        >
          <div className="text-lg font-semibold">Resume</div>
        </ClickableLink>
        <div className="hidden w-4 sm:block"></div>
        <div className="hidden font-semibold text-lg sm:block">|</div>
        <div className="hidden w-4 sm:block"></div>
        <ClickableLink
          href="https://www.linkedin.com/in/ethan-r-yu/"
          onClick={() => {
            trackSocialClick('LinkedIn');
          }}
        >
          <div className="text-lg font-semibold">LinkedIn</div>
        </ClickableLink>
        <div className="hidden w-4 sm:block"></div>
        <div className="hidden font-semibold text-lg sm:block">|</div>
        <div className="hidden w-4 sm:block"></div>
        <ClickableLink
          href="mailto:ethan@openai.com"
          onClick={() => {
            trackContactAttempt('email', { address: 'ethan@openai.com' });
          }}
          onMouseEnter={() => setIsEmailHovered(true)}
          onMouseLeave={() => setIsEmailHovered(false)}
        >
          <div className="text-lg font-semibold">{isEmailHovered ? 'ethan@openai.com' : 'Email'}</div>
        </ClickableLink>
      </div>
    </div>
  );
};

export default Home;
